import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';
import { IIntegrationQueueApi } from './base';
import { IntegrationQueueRequest } from '../models/request';
import { IntegrationQueueResponse } from '../models/response';
import { PaginationResponse } from '../models/common/paginationResponse';
import { TimeoutRequestConfigurationEnum } from '../services/enum/TimeoutRequestConfigurationEnum';

const baseRoute: string = 'IntegrationQueue';

export class IntegrationQueueApi extends IIntegrationQueueApi {

  getDomainStatus(): Promise<AxiosResponse<Result<KeyValue>>> {
    return api.get(`${baseRoute}/integrationqueuestatus`);
  }

  getSearchGrid(
    request: IntegrationQueueRequest
  ): Promise<AxiosResponse<PaginationResponse<IntegrationQueueResponse[]>>> {
    return api.get(`${baseRoute}`, { params: request });
  }

  updateQueueStatus(
    guidIntegrationQueue: string
  ): Promise<AxiosResponse<Result<void>, any>> {
    return api.post(`${baseRoute}/updatequeuestatus`, {
      guidIntegrationQueue
    });
  }

  resend(
    guidIntegrationQueue: string
  ): Promise<AxiosResponse<Result<void>, any>> {
    return api.post(
      `${baseRoute}/resend`,
      {
        guidIntegrationQueue
      },
      { timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds }
    );
  }

  addBackToQueue(
    guidIntegrationQueue: string
  ): Promise<AxiosResponse<Result<void>, any>> {
    return api.post(
      `${baseRoute}/addbacktoqueue`,
      {
        guidIntegrationQueue
      },
      { timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds }
    );
  }
}
